import { apiGet, apiPost, apiPatch, apiDelete } from "./client.ts";
import type { PlanLimits, PaidPlanTier } from "@vms/tubeforge-shared";
import type { PlanPrice } from "@/pages/billing/plan-price.ts";

export const billingApi = {
  // Plans
  // (session 10, P1/P2) each plan with its configured Stripe price; `annualUsd` null → no annual price configured
  plans: () => apiGet<{ plans: (PlanLimits & { price: PlanPrice })[] }>("/billing/plans"),

  publishableKey: () =>
    apiGet<{ publishableKey: string }>("/billing/publishable-key"),

  // Subscriptions (Elements flow)
  setupIntent: () =>
    apiPost<{ clientSecret: string }>("/billing/setup-intent"),

  createSubscription: (data: {
    plan: PaidPlanTier;
    billingCycle: "monthly" | "annually";
    paymentMethodId: string;
  }) =>
    apiPost<{
      subscriptionId: string;
      clientSecret: string | null;
      status: string;
    }>("/billing/subscription", data),

  updateSubscription: (data: {
    plan: PaidPlanTier;
    billingCycle: "monthly" | "annually";
  }) => apiPatch<{ subscriptionId: string }>("/billing/subscription", data),

  getSubscription: () => apiGet<any>("/billing/subscription"),

  cancelSubscription: () =>
    apiPost<{ ok: boolean }>("/billing/subscription/cancel"),

  reactivateSubscription: () =>
    apiPost<{ ok: boolean }>("/billing/subscription/reactivate"),

  // Legacy portal (kept for manage-subscription fallback)
  portal: () => apiPost<{ url: string }>("/billing/portal"),

  // Payment methods
  paymentMethods: () =>
    apiGet<{
      methods: Array<{
        id: string;
        brand: string | null;
        last4: string | null;
        expMonth: number | null;
        expYear: number | null;
      }>;
    }>("/billing/payment-methods"),

  addPaymentMethod: (paymentMethodId: string) =>
    apiPost("/billing/payment-methods", { paymentMethodId }),

  removePaymentMethod: (id: string) =>
    apiDelete(`/billing/payment-methods/${id}`),

  setDefaultPaymentMethod: (id: string) =>
    apiPatch(`/billing/payment-methods/${id}/default`),

  // Invoices
  invoices: () =>
    apiGet<{
      invoices: Array<{
        id: string;
        amount: number;
        currency: string;
        status: string | null;
        created: number;
        pdfUrl: string | null;
        hostedUrl: string | null;
      }>;
    }>("/billing/invoices"),
};
